import { CancelOutlined } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import "./PartnerPromotionForm.scss";

import PEPCoupon from "./ServiceCouponMobile.png";
import PrintIcon from "@mui/icons-material/Print";

export default function PartnerPromotionForm(props) {
  // logo = { logo };
  // currState = { currState };
  // context = { context };
  // data = { data };
  const printCouponLink =
    "https://pepboys-image-production.s3.us-east-1.amazonaws.com/June25/JUN25+MGR+Special+Print-Web+Coupon.jpg";
  const appointmentLink =
    "https://www.pepboys.com/appointment?dynServiceID=SpecialPackage";
  const { t } = useTranslation();
  return (
    <div className="confirmForm-promotion">
      <div className="coupon-container">
        <div className="flexItem-promotion">
          <img className="PEPCoupon" src={PEPCoupon} alt="" />
        </div>
        <div className="coupon-text-container">
          <div style={{ fontSize: "12px", color: "#8b8b8b" }}>
            SERVICE COUPON
          </div>
          <div className="special-title">Just $140 With Manager Special</div>
          <p className="special-description">
            Make an appointment for our Manager’s Special for a courtesy vehicle
            inspection† along with a full synthetic oil change, tire rotation,
            and wiper blade replacement.
          </p>
          <div>
            Expires 6/30/25
            <p className="extra-description">
              *Oil change includes oil filter up to $4.99 with an additional
              cost for oil above 5qts. Excludes PR. See pepboys.com for coupon;
              terms apply.
            </p>
          </div>
          <div className="btnContainerPromotion">
            <div className="btnComponent">
              <button
                className="printBtn"
                onClick={() => {
                  window.open(printCouponLink, "_blank");
                }}
              >
                <PrintIcon className="printerIcon" style={{ marginRight: 8 }} />
                <span style={{ color: "white" }}>Print Coupon</span>
              </button>
            </div>
            <div className="btnComponent">
              <button
                className="printBtn"
                style={{ background: "rgb(227, 24, 55)" }}
                onClick={() => {
                  window.open(appointmentLink, "_blank");
                }}
              >
                {/* <PrintIcon className="printerIcon" style={{ marginRight: 8 }} /> */}
                <span style={{ color: "white" }}>Make an Appointment</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className="footerContainer"
        style={{ display: "flex", backgroundColor: "rgb(187, 187, 187)" }}
      >
        <div>
          <button
            id="cancelButton"
            type="button"
            className="footer"
            style={{
              background: "rgb(187, 187, 187)",
              color: "rgb(187, 187, 187)",
              paddingLeft: 14,
            }}
          >
            <CancelOutlined
              style={{
                width: 20,
                backgroundColor: "rgb(187, 187, 187)",
                color: "rgb(187, 187, 187)",
                marginRight: 4,
              }}
            />
            <span style={{ marginLeft: "0px" }}>
              {t("description.CancelCallButton1")}
            </span>
          </button>
        </div>
        <div>
          <button
            /*onClick={onSubmit}*/ className="ui-btn"
            style={{
              color: "rgb(187, 187, 187)",
              background: "rgb(187, 187, 187)",
            }}
          >
            {t("description.ConfirmDestinationListButton")}
          </button>
        </div>
      </div>
    </div>
  );
}
